import { RestClient } from '@/api/rest-client'
import { Branch } from '@/api/model/branch'
import { cloneDeep } from 'lodash'
import { Company } from '@/api/model/company'
import { Pipeline } from '@/api/model/pipeline'

export class BranchClient extends RestClient<Branch> {
    collectionName = 'branches'
    parseData = Branch.fromData

    async create(data: Branch): Promise<Branch> {
        const request = cloneDeep<any>(data)

        if (data.company instanceof Company) {
            request.company = data.company.resourceIdentifier
        }

        if (data.pipelines) {
            request.pipelines = data.pipelines
                .filter((pipeline: Pipeline) => pipeline instanceof Pipeline)
                .map((pipeline: Pipeline) => pipeline.resourceIdentifier)
        }

        return super.create(request)
    }

    async update(id: string, data: Branch): Promise<Branch> {
        const request = cloneDeep<any>(data)

        if (data.company instanceof Company) {
            request.company = data.company.resourceIdentifier
        }

        return super.update(id, request)
    }
}
